module.exports = __webpack_public_path__ + "img/appAsset-cardbrand--Visa.36572556.svg";